export default {
    /** 产品中心 */
    PRODUCT_CENTER: '/product_center',
    /** 版本信息 */
    VERSION_INFO: '/vip/:feature?',
    /** 企业信息 */
    CORP_INFO: '/corp_info',
    NO_AUTH: '/no_auth',
    /** 订单信息 */
    ORDER_INFO: '/order',
    CONTACTS_INTERNAL: '/internal',
    CONTACTS_EXTERNAL: '/external',
    CONTACTS_INTERCONNECTED: '/interconnected',
    /** 成员信息管理 */
    MEMBER_MANAGEMENT: '/member',
    CONTACTS_MANAGER: '/manager',
    /** 权限查询 */
    AUTH_QUERY: '/auth_query/:tabKey',
    /** 权限查询-管理组查询 */
    MANAGE_GROUP: '/auth_query/manage_group',
    PRODUCT_SETTING: '/suite_setting',
    CORP_SETTING: {
        INDEX: '/corp_setting'
    },
    DATA_INTERFACE: '/data_interface',
    USAGE_STATISTICS: '/usage_statistics',
    CORP_LOG: '/corp_log',
    PRODUCT_LOG: '/product_log',
    // 插件设计
    OPEN: {
        /** 开放市场 */
        MARKET: '/market/:type?',
        /** 插件管理 */
        MANAGE_PLUGIN: '/manage/plugin',
        /** 数据源管理 */
        MANAGE_DATA_SOURCE: '/manage/data_source',
        /** 自建插件 */
        PRIVATE_PLUGIN: '/dev/private_plugin',
        /** 自建插件 - 插件依赖管理（子页面，无独立 tab） */
        PRIVATE_PLUGIN_DEPENDENCY: '/dev/private_plugin/dependency',
        /** 开发文档 */
        DOC: '/doc',
        /** API KEY */
        API_KEY: '/key/api_key',
        /** API调用日志 */
        API_LOG: '/key/api_log',
        /** 第三方授权 */
        AUTH: '/key/auth',
        /** MCP */
        MCP: '/mcp'
    }
};
